import CityPageTemplate from "../city-template/CityPageTemplate";
import { rosevilleConfig } from "./data";

export default function RosevilleMIPage() {
  return <CityPageTemplate config={rosevilleConfig} />;
}